import React from "react";

const KuwaitProcedure = () => {
  return (
    <div className="pccExpContainer">
      <h2>
        Procedure for Kuwait<span> PCC</span> Verification in Bangalore{" "}
      </h2>
      <p>
        The process of Kuwait PCC verification includes several critical steps,
        which Goodway Attestation Services handles with precision and
        efficiency:
      </p>
      <ul>
        <li>
          <h3>
            <span>1.</span> Application Submission:
          </h3>{" "}
          The process begins with submitting the PCC application and supporting
          documents to the local police department or relevant authority.
        </li>
        <li>
          <h3>
            <span>2.</span> Background Check:
          </h3>{" "}
          The police department conducts a thorough background check to verify
          the applicant's criminal record and personal details.
        </li>
        <li>
          <h3>
            <span>3.</span> Issuance of PCC:
          </h3>{" "}
          Upon successful verification, the police department issues the PCC
          certifying that the applicant has no criminal history.
        </li>
        <li>
          <h3>
            {" "}
            <span>4.</span>State Home Department Attestation:
          </h3>{" "}
          The issued PCC is attested by the State Home Department to
          authenticate its validity at the state level.
        </li>
        <li>
          <h3>
            {" "}
            <span>5.</span> Ministry of External Affairs (MEA) Attestation:
          </h3>{" "}
          The document undergoes attestation by the Ministry of External Affairs
          to confirm its authenticity for international use.
        </li>
        <li>
          <h3>
            {" "}
            <span>6.</span> Embassy Attestation:
          </h3>{" "}
          The final step involves attesting the PCC at the Kuwait Embassy in
          India, ensuring recognition and acceptance by Kuwaiti authorities.
        </li>
      </ul>
    </div>
  );
};

export default KuwaitProcedure;
